import React from 'react'
import { BillingMethod } from '../../types/agreement'

const ALL_OPTIONS: Array<{ value: BillingMethod; label: string; helper?: string }> = [
  { value: '', label: 'Select billing method...' },
  {
    value: 'per_period',
    label: 'Per period',
    helper: 'Bill the full contract amount each billing period.',
  },
  {
    value: 'divide_total',
    label: 'Divide total',
    helper: 'Divide the total contract value across the billing periods.',
  },
  {
    value: 'actual_usage',
    label: 'Actual usage',
    helper: 'Bill only for variable line items based on what was actually used.',
  },
  {
    value: 'progress',
    label: 'Progress (milestone billing)',
    helper: 'Bill according to the milestone schedule (% of total per phase).',
  },
]

interface Props {
  value: string
  onChange: (value: BillingMethod) => void
  className?: string
  disabled?: boolean
  id?: string
  showHelper?: boolean
  billingFrequency?: string
}

export default function BillingMethodSelect({
  value,
  onChange,
  className,
  disabled,
  id,
  showHelper = true,
  billingFrequency,
}: Props) {
  const options =
    billingFrequency === 'progress'
      ? ALL_OPTIONS.filter((o) => o.value === '' || o.value === 'progress')
      : ALL_OPTIONS.filter((o) => o.value !== 'progress')

  const selected = ALL_OPTIONS.find((o) => o.value === value)
  return (
    <div>
      <select
        id={id}
        value={value || ''}
        onChange={(e) => onChange(e.target.value as BillingMethod)}
        disabled={disabled || billingFrequency === 'progress'}
        className={
          className ||
          'w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-blue-500'
        }
      >
        {options.map((opt) => (
          <option key={opt.value || 'empty'} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {showHelper && selected?.helper && (
        <p className="mt-1 text-xs text-gray-500">{selected.helper}</p>
      )}
    </div>
  )
}
